import React from 'react'
import PropTypes from 'prop-types'
import { withRouter, NavLink } from 'react-router-dom'
import ToggleOpen from '../../decorators/ToggleOpen'
import './Dropdown.sass'

class DropdownItem extends React.PureComponent {
  /* eslint-disable */
  static propTypes = {
    id: PropTypes.number,
    name: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    toggleOpen: PropTypes.func.isRequired,
    handleClick: PropTypes.func.isRequired
  }

  render () {
    const {registries, isOpen, toggleOpen, handleClick, title} = this.props
    return (
      <li className="nav-list__dropdown nav-list__dropdown-item">
        <NavLink
          activeClassName="nav-list__item_active"
          className={`nav-list__dropdown-caption ${isOpen ? 'active':''}`}
          to="/registries"
          onClick={toggleOpen}
        >
          {title}
        </NavLink>
        {isOpen &&
          <ul className="dropdown">
            <div className="overlay" onClick={toggleOpen} />
            <ul className="dropdown__list">
              <li className="dropdown__list-item">
                <NavLink
                  activeClassName="nav-list__item_active"
                  to="/agents"
                  onClick={handleClick}
                >
                  Заявители
                </NavLink>
              </li>
              {registries.map((registry) => {
                return (
                  <li key={registry.id} className="dropdown__list-item">
                    <NavLink
                      activeClassName="nav-list__item_active"
                      to={"/registries/" + registry.id}
                      onClick={handleClick}
                    >
                      {registry.name}
                    </NavLink>
                  </li>
                )
              })}
            </ul>
          </ul>
        }
      </li>
    )
  }
}

export default withRouter(ToggleOpen(DropdownItem))



// WEBPACK FOOTER //
// ./components/DropdownItem/index.jsx